import { gql } from "@apollo/client";

import calibrationNodeFragment from "./calibration-node-fragment";

// Calibrates several ratings of one person in one save: all or nothing.
export default gql`
  ${calibrationNodeFragment}
  mutation createAssessmentAnswerCalibrations(
    $complianceProgramId: Int!
    $templateId: Int!
    $targetId: Int!
    $comment: String!
    $isSuggestion: Boolean!
    $isPrecalibration: Boolean!
    $ratings: [AssessmentAnswerCalibrationRatingInput!]!
  ) {
    createAssessmentAnswerCalibrations(
      complianceProgramId: $complianceProgramId
      templateId: $templateId
      targetId: $targetId
      comment: $comment
      isSuggestion: $isSuggestion
      isPrecalibration: $isPrecalibration
      ratings: $ratings
    ) {
      answers {
        id
        ... on RangeAssessmentAnswerNode {
          hasCalibrations
          hasCalibrationSuggestions
          comment
          integerAnswer
        }
        ... on TalentIndicatorAssessmentAnswerNode {
          hasCalibrations
          hasCalibrationSuggestions
          comment
          integerAnswer
        }
      }
      answerCalibrations {
        ...CalibrationNode
      }
    }
  }
`;
